import { Base } from 'app/components/ui/Base'
import { BgRetina } from 'app/components/ui/BgRetina'
import { Container } from 'app/components/ui/Container'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { useLayout } from 'app/contexts/LayoutProvider'
import { useGetSponsorRequest } from 'app/queries/sponsorRequests'
import { protectedRoutes } from 'app/routing/routes'
import React, { useEffect, useLayoutEffect } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { useHistory, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { SponsorRequestBox } from './SponsorRequestBox'
import { SponsorRequestDetailsCard } from './SponsorRequestDetailsCard'
import { SponsorRequestMultiupload } from './SponsorRequestMultiupload'

export const SponsorRequestShow = (): JSX.Element => {
  const handleError = useErrorHandler()
  const { push } = useHistory()

  const { sponsorRequestId } = useParams<{
    sponsorRequestId: string
  }>()

  const { updateLayoutData } = useLayout()

  const {
    data: sponsorRequest,
    error,
    isLoading,
    refetch: refetchSponsorRequest,
  } = useGetSponsorRequest({ sponsor_request_id: sponsorRequestId })

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Richiesta Sponsorizzazione',
      subTitle: sponsorRequest?.name,
      headerVariant: 'show',
    })
  }, [updateLayoutData, sponsorRequest])

  useEffect(() => {
    // Return to sponsor request list if sponsor request do not exists
    if (error?.response?.status === 404) {
      push(protectedRoutes.dashboard.path)
    }
    // Otherwise handle error normally
    else if (!!error) {
      handleError(error)
    }
  }, [error, handleError, push])

  if (isLoading) return <LoadingSpinner />

  return (
    <Base paddingTop={3}>
      <BgRetina
        bgImage='https://res.cloudinary.com/estra/image/upload/v1630336762/estra20dev/sponsor/sponsor_request_show/sponsor_request_show_bg.svg'
        bgPosition='top'
      >
        <Container>
          {sponsorRequest ? (
            <Grid>
              <SponsorRequestDetailsCard
                sponsorRequest={sponsorRequest}
              ></SponsorRequestDetailsCard>
              <SponsorRequestBox
                sponsorRequest={sponsorRequest}
              ></SponsorRequestBox>
              <SponsorRequestMultiupload
                sponsorRequest={sponsorRequest}
                refetchSponsorRequest={refetchSponsorRequest}
              />
            </Grid>
          ) : null}
        </Container>
      </BgRetina>
    </Base>
  )
}

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  max-width: 600px;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    display: grid;

    grid-template-areas:
      'Details Status'
      'Details Status'
      'Multiupload Multiupload';
    grid-template-columns: 1fr 1fr;

    max-width: none;
    margin: 0;
  }
`
